import $ from "jquery";

// global hub object (use it to emit events)
const $hub = $({});

export default $hub;
